<template>
  <transition :name="ns.b('fade')">
    <div
      v-show="visible"
      :class="[ns.b(), ns.m(type), ns.is('center', center), ns.is(effect)]"
      role="alert"
      data-test-name="alert"
      :data-test-variant="type"
      :data-test-state="[center && 'center'].join('-')"
    >
      <b-icon v-if="showIcon && iconComponent" :class="iconClass">
        <component :is="iconComponent" />
      </b-icon>

      <div :class="[ns.e('content')]">
        <span
          v-if="title || $slots.title"
          :class="[ns.e('title'), isBoldTitle]"
        >
          <slot name="title">{{ title }}</slot>
        </span>
        <p v-if="$slots.default || description" :class="ns.e('description')">
          <slot>
            {{ description }}
          </slot>
        </p>
      </div>
      <template v-if="closable">
        <div
          v-if="closeText"
          :class="[ns.e('close-btn'), ns.is('customed')]"
          @click="close"
        >
          {{ closeText }}
        </div>
        <div v-else :class="ns.e('close-btn')">
          <b-icon @click="close">
            <Close />
          </b-icon>
        </div>
      </template>
    </div>
  </transition>
</template>
<script lang="ts" setup>
import { computed, ref, useSlots } from 'vue'
import { BIcon } from '@bigin/components/icon'
import { TypeComponents, TypeComponentsMap } from '@bigin/utils'
import { useNamespace } from '@bigin/hooks'
import { alertEmits, alertProps } from './alert'

const { Close } = TypeComponents

defineOptions({
  name: 'BAlert',
})

const props = defineProps(alertProps)
const emit = defineEmits(alertEmits)
const slots = useSlots()

const ns = useNamespace('alert')

const visible = ref(true)

const iconComponent = computed(
  () => TypeComponentsMap[props.type] || TypeComponentsMap['info']
)

const iconClass = computed(() => [
  ns.e('icon'),
  { [ns.is('big')]: !!props.description || !!slots.default },
])

const isBoldTitle = computed(() => {
  return { [ns.is('bold')]: props.description || slots.default }
})

const close = (evt: MouseEvent) => {
  visible.value = false
  emit('close', evt)
}
</script>
